import { List, Text } from '@ksyos/design-system';
import { getSelectedLanguage } from '../../../../../translate';

export function PatientPermissionExtraDetails() {
    const { osasPermission } = getSelectedLanguage();

    const permissionDetails = [
        { value: osasPermission.patientPermissionExtraDetails_1 },
        {
            value: osasPermission.patientPermissionExtraDetails_2,
            valueBold: osasPermission.patientPermissionExtraDetails_2_fat,
        },
        {
            value: osasPermission.patientPermissionExtraDetails_3,
            valueBold: osasPermission.patientPermissionExtraDetails_3_fat,
        },
        {
            value: osasPermission.patientPermissionExtraDetails_4,
            valueBold: osasPermission.patientPermissionExtraDetails_4_fat,
        },
        {
            value: osasPermission.patientPermissionExtraDetails_5,
            valueBold: osasPermission.patientPermissionExtraDetails_5_fat,
        },
    ];

    return (
        <List
            styleType="bullet"
            sx={{ marginLeft: 6 }}
        >
            {permissionDetails.map((detail, index) => (
                <List.Item key={index}>
                    {
                        <Text size="sm">
                            {detail.valueBold && <b>{detail.valueBold}</b>}
                            {detail.value}
                        </Text>
                    }
                </List.Item>
            ))}
        </List>
    );
}
